import { FeatureFlags } from "../types";
import useUserInfo from "../useUserInfo";
const useKindeFeatureFlags = () => {
    const { features } = useUserInfo();
    const hasAccessToTTS = features[FeatureFlags.TTS];
    const hasAccessToV2 = features[FeatureFlags.V2];
    return {
        hasAccessToTTS,
        hasAccessToV2,
    };
};
export default useKindeFeatureFlags;
